export const countries = [
  { code: "en", name: "English", icon: "UK" },
  { code: "da", name: "Danish", icon: "DK" },
  { code: "fr", name: "French", icon: "FR" },
  { code: "nl", name: "Dutch", icon: "NL" },
  { code: "pl", name: "Polish", icon: "PL" },
  { code: "hu", name: "Hungarian", icon: "HU" },
  { code: "no", name: "Norwegian", icon: "NO" },
  { code: "it", name: "Italian", icon: "IT" },
  { code: "de", name: "German", icon: "DE" },
  { code: "sk", name: "Slovak", icon: "SK" },
  { code: "sl", name: "Slovenia", icon: "SI" },
  { code: "es", name: "Spanish", icon: "ES" },
  { code: "sv", name: "Swedish", icon: "SE" },
  { code: "tr", name: "Turkish", icon: "TR" },
  { code: "fi", name: "Finnish", icon: "FR" },
  { code: "et", name: "Estonia", icon: "EE" },
  { code: "ru", name: "Russian", icon: "RU" },
  { code: "ru", name: "Russian", icon: "RU" },
  { code: "pt", name: "Portuguese", icon: "PT" },
  { code: "ro", name: "Romanian", icon: "RO" },
  { code: "cs", name: "Czech", icon: "CZ" },
  { code: "hr", name: "Croatian", icon: "HR" },
];
